/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button{background-color:transparent}.btn_close[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#fff}@media screen and (min-width:660px){.btn_close[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{width:40px;height:auto}}"];
export { styles as styles };
